import {AfterViewInit,ChangeDetectionStrategy, Component,  ElementRef, OnDestroy, Input, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params} from '@angular/router';
//import {MaterialInstance, MaterialService} from "../../../classes/material.service";
import {StreamsService}  from "../../../services/streams.service";
import {StreamProject} from "../../../interfaces";
import {switchMap, map, delay} from 'rxjs/operators'; 
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
import * as moment from 'moment';

@Component({
  selector: 'app-stream-info',
  templateUrl: './stream-info.component.html',
 // changeDetection: ChangeDetectionStrategy.OnPush,

  styleUrls: ['./stream-info.component.scss'],
})
export class StreamInfoComponent implements OnInit, OnDestroy{
  

  @Input() stream: StreamProject;
  @ViewChild('idetInfo') infoEdit:any ;
  
  infoForm: FormGroup
 

   constructor(public streamsService:StreamsService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
    ){
}
 




  ngOnInit() {
    this.infoForm = new FormGroup({
      title: new FormControl(this.stream.title, [Validators.required]),
      description: new FormControl(this.stream.description)
    })


    //console.log()
  }


   getDescription() {
  let text = this.stream.description || "";

  function escapeHtml(s: string) {
    return s.replace(/[&<>"']/g, ch =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]!)
    );
  }

  // экранируем html
  text = escapeHtml(text);

  // заменяем переводы строк на <br/>
  text = text.replace(/\r?\n/g, "<br/>");

  // регулярка для поиска ссылок
  const urlRegex = /\b((?:https?:\/\/|www\.)[^\s<>"]+)/gi;

  // замена ссылок
  return text.replace(urlRegex, (rawUrl) => {
    let cleanUrl = rawUrl.replace(/["'<>]+$/, "");
    if (cleanUrl.startsWith("www.")) {
      cleanUrl = "http://" + cleanUrl;
    }
    return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>`;
  });
}



openEdit(){
	 
   
  this.dialogService.open(this.infoEdit,{hasScroll: true} )

}

openModal(content) {
  this.infoForm.patchValue({
    title: this.stream.title,
    description: this.stream.description

  }) 

  this.dialogService.open(content,{hasScroll: true} )

	
}


 


updateCoverFileSub$: any = null
loadCover(fileInput){
  //console.log(fileInput.files.clear())

  const file = fileInput.files[0]

  this.updateCoverFileSub$ = this.streamsService.updateCoverImage(this.stream._id, file).subscribe(
    stream=>{
      
     
     this.stream.coverImage = stream.coverImage
 
     this.stream.thumbImage = stream.thumbImage

     this.toastrService.show('','Обкладинка завантажена' , {
       status: 'success',
       position: <NbGlobalPosition>'bottom-right'
     })
    
   },error =>{ 
    // MaterialService.toast(error.error.message)
     this.toastrService.show('' ,'Обкладинка не завантажена' ,{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-right'
    })
   } 
 )

}


deleteCoverFileSub$ = null
deleteCover(){
  this.deleteCoverFileSub$ = this.streamsService.deleteCoverImage(this.stream._id).subscribe(
    stream=>{
         
     
     this.stream.coverImage = stream.coverImage
  

     this.toastrService.show('','Обкладинка видалена',{
      status: 'success',
	position: <NbGlobalPosition>'bottom-right'
    })
   
   },error =>{ 
     //MaterialService.toast(error.error.message)
     this.toastrService.show('','Не вдалося видалити обкладинку',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-right'
    })
   } 
 )


}




updateInfoSub$: any = null
submitInfoForm(modal:any){
   modal.close()

   this.infoForm.disable()

    

   this.updateInfoSub$ = this.streamsService.updateInfo(this.stream._id,this.infoForm.value.title, this.infoForm.value.description ).subscribe(
     stream=>{
       
      
      this.stream.title = stream.title

      this.stream.description = stream.description
     

     this.toastrService.show('','Інформація збережена',{
      status: 'success',
      position: <NbGlobalPosition>'bottom-right'
        })
 
    },error =>{ 
     // MaterialService.toast(error.error.message)
      this.toastrService.show('','Інформація збережена',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-right'
        })
    },
    ()=>{
      this.infoForm.enable()
    }
  )


}

  
  ngOnDestroy() {
    if(this.updateInfoSub$){
      this.updateInfoSub$.unsubscribe()
    }
 
    if(this.updateCoverFileSub$){
      this.updateCoverFileSub$.unsubscribe()
    }

    
    if(this.deleteCoverFileSub$){
      this.deleteCoverFileSub$.unsubscribe()
    }


   }
  
}
